import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage, ContactPage, CareersPage } from './pages';
import { ThemeProvider } from './providers';
import { PriorityAccessModalProvider } from './contexts/priority-access-modal-context';
import { PriorityAccessModal } from './components/priority-access-modal';
import { usePageTracking, useScrollTracking } from './hooks/useAnalytics';
import Analytics from './lib/analytics';

// Component to initialize analytics and tracking
function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  usePageTracking(); // Automatic page view tracking
  useScrollTracking(); // Scroll depth tracking
  return <>{children}</>;
}

function App() {
  // Initialize Google Analytics
  React.useEffect(() => {
    Analytics.initialize();
  }, []);

  return (
    <ThemeProvider defaultTheme="light">
      <PriorityAccessModalProvider>
        <BrowserRouter>
          <AnalyticsProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/careers" element={<CareersPage />} />
            </Routes>
          </AnalyticsProvider>
        </BrowserRouter>
        <PriorityAccessModal />
      </PriorityAccessModalProvider>
    </ThemeProvider>
  );
}

export default App;
